import { useMutation } from '@tanstack/react-query';
import { updatePagesOrder } from '../api';
import type { PageOrderItem } from '../types/myStore.types';
import { stanNotify } from '@/lib';

export function useUpdatePagesOrder(storeId: number) {
    return useMutation({
        mutationFn: (pages: PageOrderItem[]) => updatePagesOrder(storeId, pages),
        onError: (error: any) => {
            stanNotify({
                type: 'error',
                title: 'Update Failed',
                text: error.response?.data?.message || 'Failed to update page order',
            });
        },
    });
}
